import React from "react";
import WorkForceCaseImageUploadComponent from "../../../components/WorkForce/WorkForceCaseImageUploadComponent";
import {Controller} from "react-hook-form";
import WorkForceCaseImageCreateUploadComponent
    from "../../../components/WorkForce/WorkforceCaseImageCreateUploadComponent";
import {useSelector} from "react-redux";

// this view adds functionality to the antd upload class
const CaseListingDetailsImageAttachment = ({disabled = false}) => {

    return (
        <div>
            <p className="font-bold text-sm">Image Attachment</p>
            <WorkForceCaseImageUploadComponent disabled={disabled}/>

        </div>
    );
};

export default CaseListingDetailsImageAttachment;